import { advantages } from '@/mocks/data';

export default function AdvantagesSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            悠宝三岁的独特优势
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            不只是产品，更是一套完整的科学育儿体系
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {advantages.map((item, index) => (
            <div key={index} className="bg-background-50 rounded-xl p-6 text-center transition-all hover:scale-[1.02]">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}